module.exports = __webpack_public_path__ + "img/jieshao_sjgd.568e3909.png";